import "./servicebuildFleet.css";

const ServiceBuildFleet = () => {
  return (
    <div className="relative">
      <div class="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <div className="lg:col-span-2 col-span-1">
          <div className="ArielView1500E min-h-[500px] lg:border-r-[8px] border-[#b4875e] border-[0px]" />
        </div>
        <div className="lg:col-span-3 col-span-1  custom-container lg:pt-[137px] sm:pt-[90px] pt-[60px] lg:pb-[119px] sm:pb-[80px] pb-[50px] lg:px-[40px] px-[0px] lg:text-end text-center">
          <div className="lg:max-w-[700px] max-w-full">
            <div className="font-[Rockwell]  2xl:text-[36px] 2xl:text-[46px] xl:text-[40px] lg:text-[35px] text-[23px]px] text-[16px] font-extrabold	lg:mb-[35px] sm:mb-[25px] mb-[15px]">
              ADVANCED DEALER <br /> PORTAL & TELEMATICS
            </div>
            <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] font-extrabold lg:mb-[35px] sm:mb-[25px] mb-[15px]">
              ORDER PARTS, TRACK CUSTOMER ORDERS, & CHECK BATTERY HEALTH ON FLEET VEHICLES REMOTELY
            </div>
            <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] font-normal lg:mb-[90px] sm:mb-[70px] mb-[40px]">
              The Tuatara Dealer Portal is an essential tool for any dealership, designed to streamline operations and
              enhance customer service. With easy access to order parts and maintenance kits, managing inventory and
              service needs has never been more efficient. The portal also allows dealers to track orders in real time
              and remotely monitor the battery health of fleet vehicles, ensuring optimal performance and reliability.
              This comprehensive platform simplifies dealership management while keeping your fleet running smoothly,
              all from one convenient interface.
            </div>
            <div>
              <button
                className="lg:w-[70%] w-full bg-[#7ABF5B] rounded font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] lg:px-[60px] md:px-[48px] sm:px-[30px] px-[20px] lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                CREATE AN ACCOUNT
              </button>
              <button
                className="lg:w-[70%] w-full lg:mt-[56px] md:mt-[46px] mt-[26px] bg-[#292929] rounded font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] lg:px-[60px] md:px-[48px] sm:px-[30px] px-[20px] lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                DEALER PORTAL LOG-IN
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ServiceBuildFleet;
